import React, { useRef } from 'react';
import { Printer } from 'lucide-react';

const Namuna_Kh = () => {
  const documentRef = useRef(null);

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>नमूना "ख"</title>
          <style>
            /* Print Page Setup */
            @page {
              size: A4 portrait;
              margin-top: 0.3in;
              margin-bottom: 0.3in;
              margin-left: 0.75in;
              margin-right: 0.6in;
            }
            
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
              font-size: 13px;
              line-height: 1.5;
              color: #000;
              margin: 0;
              padding: 0;
            }

            .document-container {
              max-width: 100%;
              margin: 0;
              padding: 0;
            }

            /* Title Styling */
            .text-center {
              text-align: center;
            }

            .text-right{
              text-align: right;
            }

            .font-bold {
              font-weight: bold;
            }

            .text-lg {
              font-size: 16px;
            }

            .underline {
              text-decoration: underline;
            }

            .mb-6 {
              margin-bottom: 12px;
            }

            .mb-3 {
              margin-bottom: 6px;
            }

            .mb-4 {
              margin-bottom: 8px;
            }

            .mb-2 {
              margin-bottom: 4px;
            }

            .mb-16 {
              margin-bottom: 24px;
            }

            .mt-12 {
              margin-top: 20px;
            }

            .ml-10 {
              margin-left: 40px;
            }

            .ml-2 {
              margin-left: 8px;
            }

            .mr-2 {
              margin-right: 8px;
            }

            /* Text Alignment */
            .text-justify {
              text-align: justify;
              text-justify: inter-word;
            }

            /* Inline Elements */
            .inline {
              display: inline;
            }

            /* Signature Section */
            .text-4xl {
              font-size: 24px;
            }

            .italic {
              font-style: italic;
            }

            .text-gray-700 {
              color: #374151;
            }

            /* Whitespace */
            .whitespace-pre-line {
              white-space: pre-line;
            }

            /* Remove all Tailwind classes and replace with inline styles */
            div {
              page-break-inside: avoid;
            }

            /* Print Specific */
            @media print {
              body {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
              }
              
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* Print Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg"
        >
          <Printer size={20} />
          Print
        </button>
      </div>

      {/* Document Preview */}
      <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
        <div
          ref={documentRef}
          className="document-container"
          style={{
            fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "40px",
            fontSize: "14px",
            lineHeight: "1.6"
          }}
        >
          {/* Title */}
          <div className="text-center font-bold text-lg mb-6 underline">
            नमूना "ख"
          </div>

          {/* Introduction */}
          <div className="mb-6 text-justify">
            संपादन कंपनीचा किंवा संस्थेच्या वतीने करावयाचा असेल तेव्हा (नमूना 'क' मधील माहितीच्या अतिरिक्त) खालील माहिती पुरविण्यात यावी:-
          </div>

          {/* Question 1 */}
          <div className="mb-3 text-justify">
            <span className="inline mr-2 font-bold">(एक)</span>
            <span className="inline">संबंधित कंपनी / संस्था ही भूमी संपादन अधिनियम ३ (ड)च्या अर्थानुसार 'कंपनी' आहे काय?</span>
          </div>

          {/* Question 2 */}
          <div className="mb-3 text-justify">
            <span className="inline mr-2 font-bold">(दोन)</span>
            <span className="inline">ती, विहित नमून्यामधून करारपत्र करून देण्यास तयार आहे काय?</span>
          </div>

          {/* Question 3 */}
          <div className="mb-3 text-justify">
            <span className="inline mr-2 font-bold">(तीन)</span>
            <span className="inline">ती, विहित नमून्यामधून करारपत्र करून देण्यात आले त्या तारखेपासून १५ दिवसाच्या आत संपादनाचा अंदाजित खर्च जमा करू शकेल काय ? </span>
          </div>

          {/* Question 4 */}
          <div className="mb-3 text-justify">
            <span className="inline mr-2 font-bold">(चार)</span>
            <span className="inline">संपादन अधिकाऱ्याने किंवा न्यायालयाने निवाडयाद्वारे देवविलेली भरपाई अंदाजित खर्चाहून अधिक असल्यास कंपनीची आर्थिक स्थिती विचारात घेवून तो तिच्याकडून वसूल करणे शक्य होईल काय ? </span>
          </div>

          <div className="mb-3 text-justify">
            <span className="inline">कंपन्यांना औद्योगिक प्रयोजनासाठी भूमिची आवश्यकता असेल तेव्हा खालील अतिरिक्त माहिती पुरविण्यात यावी:- </span>
          </div>

          {/* Question 5 */}
          <div className="mb-3 text-justify">
            <span className="inline mr-2 font-bold">(पाच)</span>
            <span className="inline"> ज्यासाठी भूमिचा वापर करण्यात येईल असे प्रयोजन कोणते ................................................</span>
          </div>

          {/* Additional Note */}
          <div className="mb-3 text-justify">
            (आवश्यक असलेले अंदाजित क्षेत्रफळ)
          </div>

          {/* Sections (क), (ब), (क), (१), (२) */}
          <div className="mb-6">
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(क)</span>
              <span className="inline">उत्पादन कार्य, इमारतीसाठी ................................................</span>
            </div>
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(ख)</span>
              <span className="inline">कार्यालय व इतर सहायभूत इमारतीसाठी ..................................................</span>
            </div>
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(ग)</span>
              <span className="inline">मोकळी जागा किंवा रस्ते यासाठी .................................................</span>
            </div>
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(घ)</span>
              <span className="inline">विस्ताराच्या गरजेसाठी .............................................................</span>
            </div>
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(ड)</span>
              <span className="inline">अन्य कोणत्याही प्रयोजनासाठी, उदा. वाहत जाणाऱ्या पाण्यासाठी जागेची सोय करणे .................................................(कृपया तपशील नमूद करा)</span>
            </div>
          </div>

          {/* Question 6 */}
          <div className="mb-6 text-justify">
            <span className="inline mr-2 font-bold">(सहा)</span>
            <span className="inline">संबंधित भूमिसंपादन विद्यमान उपक्रम मुंबई शहराबाहेर हलविण्याशी संबंधित आहे काय? तसे असल्यास, त्याबाबत संबंध तपशील आणि त्याचे सद्याचे ठिकाण नमूद करा.</span>
          </div>

          {/* Question 7 */}
          <div className="mb-6 text-justify">
            <span className="inline mr-2 font-bold">(सात)</span>
            <span className="inline">प्रस्तुत औद्योगिक उपक्रम उद्योग (विकास व विनिमय) अधिनियम, १९५१ यामध्ये समाविष्ट आहे काय? </span>
          </div>

          {/* Sections (क), (ख) */}
          <div className="mb-6">
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(क)</span>
              <span className="inline">तसे असल्यास, केंद्र शासनाचा आवश्यक लायसन्यचा क्रमांक व तारीख किंवा लायसनसाठी केलेल्या अर्जाची तारीख नमूद करावी. </span>
            </div>
            <div className="ml-10 mb-2">
              <span className="inline mr-2">(ख)</span>
              <span className="inline">कंपनीच्या लायसनासाठी केलेल्या अर्ज अद्याप निकालात आला नसेल तर, केंद्र शासनाने निदान कंपनीच्या योजनेस प्रारंभिक मान्यता दिली आहे किंवा काय, ते नमूद करावे. </span>
            </div>
          </div>

          <div className="mb-3 text-justify">
            (कृपया पत्र क्र. व तारीख उद्रधृत करावी)
          </div>

          {/* Question 8 */}
          <div className="mb-4 text-justify">
            <span className="inline mr-2 font-bold">(आठ)</span>
            <span className="inline">संपादनासाठी प्रस्तावित केलेले क्षेत्र नगरपालिका क्षेत्रात आहे काय ? अशा प्रकारणी नगरपालिकेने बांधकामास आवश्यक परवानगी दिली असल्यास तसे नमूद करावे. </span>
          </div>

          {/* Sub-sections */}
          <div className="mb-4">
            <div className="ml-10 mb-3 text-justify">
              <span className="inline mr-2">टिप:- </span>
              <span className="inline">प्रमाणानुसार तयार केलेल्या रेखांकनाच्या नकाशाची प्रत, कलम ६ खालील अंतिम अधिसूचना काढण्यात येण्यापूर्वी उद्योग संचालकाकडे पाठविण्यात यावी.</span>
            </div>

            <div className="ml-10">
              <span className="inline">(शासकीय परिपत्रक, महसूल विभाग क्र.एलक्यू २५.५.०९-३५६६५-५ दि. १६ नोव्हें. १९५९) </span>
            </div>
          </div>

          <div className="mb-3 text-justify">
            कंपनीला / संस्थेला गृहनिर्माणासाठी भूमि आवश्यक असल्यास पुढील अतिरिक्त माहिती पुरविण्यात यावी:-
          </div>

          {/* Question 9 */}
          <div className="mb-6 text-justify">
            <span className="inline mr-2 font-bold">(नऊ)</span>
            <span className="inline"> गृहनिर्माण योजना शासनाकडून मान्य करण्यात आली आहे काय आणि नसल्यास, ती शासनाकडून मान्य करण्यात यावी काय? </span>
          </div>

          {/* Closing Questions */}
          <div className="mb-6">
            <div className="mb-3 text-justify">
              <span className='font-bold'>(दहा)</span> शासनाने संपादनाचा खर्च पूर्णत: किंवा काही अंशी सोसण्याचे मान्य केले आहे काय?
            </div>
            <div className="mb-3 text-justify">
              <span className='font-bold'>(अकरा)</span> घरात निवास व्यवस्था केली जाईल अशा कुटुंबाची / संस्थेच्या सदस्याची सदस्या किती ?
            </div>
            <div className="mb-3 text-justify">
              <span className='font-bold'>(बारा)</span> त्याच्या पैकी कोणाचेही घर किंवा घराची जागा आहे काय, असल्यास कोठे आहे?
            </div>
            <div className="mb-3 text-justify">
              <span className='font-bold'>(तेरा)</span> जागा सार्वजनिक आरोग्य विभागाने मान्य केली आहे काय ?
            </div>
          </div>

          {/* Signature with handwritten effect */}
          <div className="mt-12 text-right">
            <div className="mb-16">
              {/* Simulated signature line */}
              <div className="text-4xl font-bold italic text-gray-700 mb-2" style={{ fontFamily: 'cursive' }}>
              </div>
            </div>
            <div className="font-bold">
              उपकार्यकारी अभियंता, (बांधकाम विभाग),
            </div>
            <div className="font-bold">
              दक्षिण मध्य रेल्वे, अकोला
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Namuna_Kh;